<template>
  <section>
    <h4 class="form-card-header">{{ $t('registration.account-info') }}</h4>
    <div class="form-card-form">
      <div>
        <label for="pi_bank">{{ $t('registration.bank') }}:<span class="text-danger">*</span></label>
        <select id="pi_bank"
                name="bank_name"
                v-model="v$.form.bank.$model"
                @blur="v$.form.bank.$touch()"
                class="form-select dropdown-color">
          <option v-for="(item, index) in banks" :key="index" :value="index">{{ item }}</option>
        </select>
        <div class="error-message" v-show="v$.form.bank.$errors.length">
          <div v-show="!v$.form.bank.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_account">{{ $t('registration.bank-account-number') }}:<span class="text-danger">*</span></label>
        <input id="pi_account"
               size="sm"
               name="account_number"
               type="number"
               class="pi-input"
               v-model="v$.form.accountNumber.$model"
               @blur="v$.form.accountNumber.$touch()" />
        <div class="error-message" v-show="v$.form.accountNumber.$errors.length">
          <div v-show="!v$.form.accountNumber.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_account_name">{{ $t('registration.bank-account-name') }}:<span class="text-danger">*</span></label>
        <input size="sm"
               id="pi_account_name"
               type="text"
               :name="isChild ? 'bank_account_holder' : ''"
               :class="isChild ? 'pi-input' : 'pi-input cursor-not-allowed'"
               :disabled="!isChild"
               v-model="v$.form.accountName.$model"
               @blur="v$.form.accountName().$touch()"
        />
        <input id="pi_account_name"
               v-if='!isChild'
               name="bank_account_holder"
               size="sm"
               type="text"
               v-show='false'
               class="pi-input cursor-not-allowed"
               :value="accountName"
        />
      </div>

      <section class="sub-step-buttons-container">
        <ic-button size="tn" type="button" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>{{ $t('button.previous') }}</ic-button>
        <ic-button size="tn" type="button" variant="success"  @click="next()" class="d-flex align-items-center ml-3">{{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
    </div>
  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, numeric, required } from '@vuelidate/validators'
import { TransactionBanks } from '../../utils/constants'
import { nameRegexValidator } from '../../mixins/regex'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    banks: {
      type: Object,
    },
    accountName: {
      type: String,
      default: '',
    },
    isChild: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        bank: null,
        accountNumber: null,
        accountName: null,
      }
    }
  },
  validations() {
    return {
      form: {
        bank: {
          required
        },
        accountNumber: {
          required, numeric,
        },
        accountName: {
          required, nameRegexValidator
        },
      }
    }
  },
  mounted() {
    this.fillOldData()
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      this.form.accountName = this.v$.form.accountName.$model
      console.debug('(AccountInfo.vue) form.accountName: ', this.form.accountName)
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    fillOldData() {
      if (!window.oldInputs) return;
      if (window.oldInputs['account_number']) {
        Vue.set(this.form, 'account_number', window.oldInputs['account_number']);
      }
      if (window.oldInputs['bank_account_holder']) {
        Vue.set(this.form, 'bank_account_holder', window.oldInputs['bank_account_holder']);
      }
    }
  },
  watch: {
    accountName() {
      console.debug('(AccountInfo.vue) accountName: ', this.accountName)
      this.form.accountName = this.accountName
      this.v$.form.accountName.$model = this.accountName
    },
  }
}
</script>